import { openkit } from "../../library/database";

export const addTicketToCart = async ({
  quantity,
  info,
  product,
  extraReservationConfig,
  clientRequest,
  setAddedToCart,
}) => {
  try {
    const cartItem = {
      type: "monument",
      product_id: product.id,
      client_id: info.user.id,
      quantity: quantity,
      date: info.monument?.date,
      request: clientRequest,
    };
    await openkit.data.create("c_reservation_lines", cartItem);
    setAddedToCart(true);
  } catch (error) {
    console.log("error :>> ", error);
  }
};
